<div class="form-group">
  <small class="form-text" *ngIf="fieldControl?.dirty && fieldControl?.errors">
  {{ errors.required || errors.minlength || errors.maxlength || errors.email || errors.username }}
  </small>
  <div>
    <input
      class="form-control"
      [type]="type || 'text'"
      [placeholder]="placeholder"
      [formControlName]="fieldControlName"
      (input)="patternRestriction($event)"
    />
    <ng-container *ngIf="fieldControlName === 'password'">
      <i class="fas fa-eye" *ngIf="type === 'password'" (click)="type = 'text'"></i>
      <i class="fas fa-eye-slash" *ngIf="type === 'text'" (click)="type = 'password'"></i>
    </ng-container>
  </div>
</div>
